export const GET_AGES = "GET_AGES";
export const GET_AGE_BY_ID = "GET_AGE_BY_ID";
export const UPDATE_AGE = "UPDATE_AGE";
export const DELETE_AGE = "DELETE_AGE";
export const CREATE_AGE = "CREATE_AGE";
export const GET_PROGRAMS_BY_AGE = "GET_PROGRAMS_BY_AGE";
